import LegalPageLayout from '@/components/feature/LegalPageLayout';

export default function DistanceSalesPage() {
  return (
    <LegalPageLayout title="Mesafeli Satış Sözleşmesi">
      <p>Bu Mesafeli Satış Sözleşmesi, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği uyarınca hazırlanmıştır.</p>

      <h4>1. Taraflar</h4>
      <p><strong>Satıcı:</strong> Atak Sistem Enerji<br />
      <strong>Alıcı:</strong> Web sitesi veya WhatsApp üzerinden ürün/hizmet satın alan gerçek veya tüzel kişi</p>

      <h4>2. Sözleşme Konusu</h4>
      <p>İşbu sözleşmenin konusu, satıcının alıcıya sunduğu Fineco Isı Pompası, kat kaloriferi ve güneş enerjisi sistemleri ürün ve hizmetlerinin satışı ve teslimine ilişkin tarafların hak ve yükümlülüklerinin belirlenmesidir.</p>

      <h4>3. Sözleşme Konusu Ürün/Hizmet</h4>
      <p>Sipariş formunda belirtilen ürün/hizmetin türü, miktarı, markası, satış bedeli, ödeme şekli ve teslimat bilgileri sözleşmenin ayrılmaz parçasıdır.</p>

      <h4>4. Cayma Hakkı</h4>
      <p>Alıcı, ürünün kendisine veya gösterdiği kişiye teslim tarihinden itibaren 14 (on dört) gün içinde cayma hakkına sahiptir. Hizmet sözleşmelerinde cayma süresi sözleşmenin kurulduğu günden itibaren başlar.</p>

      <h4>5. Cayma Hakkının İstisnaları</h4>
      <p>Alıcının özel istek ve talepleri doğrultusunda üretilen, kişiye özel hale getirilen veya montajı/kurulumu yapılmış ürünlerde cayma hakkı kullanılamaz.</p>

      <h4>6. Ödeme ve Teslimat</h4>
      <p>Ödeme, taraflarca kararlaştırılan yöntemle gerçekleştirilir. Teslimat süresi ve şartları sipariş onayında belirtilir.</p>

      <h4>7. Uyuşmazlık Çözümü</h4>
      <p>İşbu sözleşmeden doğan uyuşmazlıklarda Tüketici Hakem Heyetleri ve Tüketici Mahkemeleri yetkilidir.</p>

      <p><strong>Atak Sistem Enerji</strong></p>
    </LegalPageLayout>
  );
}